export enum BtnLoadingState {
  NONE,
  SAVE,
  SAVE_AND_STAY,
  PUBLISH,
}
